import styled from 'styled-components'

export const Main = styled.div`
    display: flex;
    margin-bottom: 20px;
    font-size: 12px;

    * {
      margin-right: 10px;
    }
 `

export const Results = styled.div`
    color: #414042;
 `

export const QuantityOfProducts = styled.div`
    color: #0071ce;
    font-weight: bold;
 `

export const SelectedArrow = styled.img`
  height: 8px;
`

export const QuantitySelectedOfProducts = styled.div`
    line-height: 28px;
    
    :hover {
        color: #0071ce;
        font-weight: bold;
    }
    
    color: ${({ isActive }) => (isActive ? '#0071ce' : 'inherit')};
    font-weight: ${({ isActive }) => (isActive ? 'bold' : 'inherit')};
 `

export const QuantitySelectedOfProductsIcon = styled.img`
  height: 5px;
  margin-left: 10px;
`

export const OptionSelectHitsPerPage = styled.div`
  margin-bottom: 10px;
  color: #414042;
  font-size: 16px; 
  font-weight: bold;
`
